import React from "react";
import { useNavigate } from "react-router-dom";
import "./HomePage.css";

export default function HomePage() {
  const navigate = useNavigate();
  return (
    <div
      className="container"
      style={{
        background: "linear-gradient(135deg, #4CAF50 0%, #66BB6A 100%)",
        minHeight: "100vh",
        backgroundImage: `url(${process.env.PUBLIC_URL + "/img/background.webp"})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
      }}
    >
      <div className="content">
        <h1 className="title">世界防霉日</h1>
        <h2 className="subtitle">Global Mold Awareness Day</h2>
        <p className="tagline">
          Together for Earth, Together for Health.<br />
          Happy Home, Happy Life.
        </p>
        <h3 className="question">你認識黴菌了嗎？</h3>
        <div className="description">
          在我們的日常生活中，黴菌是長期存在的，實際於那些你以為「乾淨很安全」的地方。<br /><br />
          黴菌看不見，但危險真實存在，認知是保護的第一步。<br />
          黴菌不僅是環境問題，它還會對我們的身心可能影響我們的生活品質與健康，<br />
          從過敏、呼吸道問題到食品安全，無處不在。<br />
          然而，我們並不是要與黴菌對抗，而是要與其共存。<br />
          我們要做的是認識黴菌，了解如何防範它的威脅，<br />
          讓我們能夠的呼吸空間的同時，也能維護我們的環境。<br /><br />
          我們發起這個專題「黴菌行動」，<br />
          打響認知，重新發現並學會認識的黴菌威脅。<br />
          讓我們從認識開始開始，邁向更純淨的環境，一同守護我們的家園與健康！
        </div>
        <button className="cta-button" onClick={() => navigate("/survey")}>開始挑戰</button>
      </div>
      <div className="earth-character">
        <img src={process.env.PUBLIC_URL + "/img/earth.webp"} alt="Earth Character" />
      </div>
    </div>
  );
}
